export default class ToxinsUsed {
    constructor(typeOfPoison, toxin, group, legalStatus) {
        this.typeOfPoison = typeOfPoison;
        this.toxin = toxin;
        this.group = group;
        this.legalStatus = legalStatus;
    }
}